import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "antd";
import "./evaluationsConfigSummary.scss";


function EvaluationsConfigSummary({ qhjid,ev_id,evalDesc,localQDesc  }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [SelectedSkills, setSelectedSkills] = useState("");
  const [mCount, setMCount] = useState(0);
  const [oCount, setOCount] = useState(0);
  
  var tmpSkills= ""
  useEffect(() => {
    //console.log(pageResult, "PageResults");
    evalDesc.skillarray?.map((skill,idx) => (                                                        
              tmpSkills =  skill.skill + " " + tmpSkills
      ))
    setSelectedSkills(tmpSkills)
    handleMandatoryQ()
  }, [localQDesc]);

  const handleModify = () => {
    if (location.state?.cameFromResumes) {
      navigate(-1);
    } else {
      navigate("/resumes");
    }
  };

  const handleMandatoryQ = () => {
     var mcount =0
     var ocount =0
     for(let idx = 0; idx < localQDesc?.length; idx++){ 
        var skillItem = evalDesc?.skillarray.filter((item)=>item.skill.toLowerCase() == localQDesc[idx].skill.toLowerCase()) 
        if(skillItem[0] != null) {
          if(skillItem[0].weightage == 1){
             mcount = mcount+1
          }else{
             ocount = ocount +1
          }   
        }
     }
     setMCount(mcount)
     setOCount(ocount)
     return
  };
  const handleOptionalQ = () => {
     return localQDesc?.filter((item)=> item.weightage == "Optional").length
    
  };

  return (
    <div className="evaluationsConfigSummary-wrapper">
      <div className="resumeResultsSearchSummary-keywords">
          <div>
              {SelectedSkills}
          </div>          
      </div>
      <div className="resumeResultsSearchSummary-details-grid">
        <div className="resumeResultsSearchSummary-detail-item">
          Total Q : <b>{localQDesc?.length==""?"0":localQDesc?.length}</b>
        </div>
        <div className="resumeResultsSearchSummary-detail-item">
          Mandatory Q : <b>{mCount}</b>
        </div>      
        <div className="resumeResultsSearchSummary-detail-item">
          Optional Q : <b>{oCount}</b>
        </div>                  
      </div>
    </div>
  );
}

export default EvaluationsConfigSummary;
